// FETCH ALL PROPERTIES FROM STITCHING_INWARD DETAILS
export const FETCH_STITCHING_INWARD_DETAILS_REQUEST = 'FETCH_STITCHING_INWARD_DETAILS_REQUEST';
export const FETCH_STITCHING_INWARD_DETAILS_SUCCESS = 'FETCH_STITCHING_INWARD_DETAILS_SUCCESS';
export const FETCH_STITCHING_INWARD_DETAILS_FAILURE = 'FETCH_STITCHING_INWARD_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM STITCHING_INWARD DETAILS BY ID
export const FETCH_STITCHING_INWARD_DETAILS_BY_ID_REQUEST = 'FETCH_STITCHING_INWARD_DETAILS_BY_ID_REQUEST';
export const FETCH_STITCHING_INWARD_DETAILS_BY_ID_SUCCESS = 'FETCH_STITCHING_INWARD_DETAILS_BY_ID_SUCCESS';
export const FETCH_STITCHING_INWARD_DETAILS_BY_ID_FAILURE = 'FETCH_STITCHING_INWARD_DETAILS_BY_ID_FAILURE';

// FETCH ALL PROPERTIES FROM STITCHING_INWARD DETAILS BY ID
export const FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_REQUEST = 'FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_REQUEST';
export const FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_SUCCESS = 'FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_SUCCESS';
export const FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_FAILURE = 'FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_FAILURE';

// CREATE PROPERTIES FOR STITCHING_INWARD DETAILS
export const CREATE_STITCHING_INWARD_DETAILS_REQUEST = 'CREATE_STITCHING_INWARD_DETAILS_REQUEST';
export const CREATE_STITCHING_INWARD_DETAILS_SUCCESS = 'CREATE_STITCHING_INWARD_DETAILS_SUCCESS';
export const CREATE_STITCHING_INWARD_DETAILS_FAILURE = 'CREATE_STITCHING_INWARD_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_STITCHING_INWARD_DETAILS = 'CREATE_USER_FORM_STITCHING_INWARD_DETAILS';

// UPDATE PROPERTIES FOR STITCHING_INWARD DETAILS
export const UPDATE_STITCHING_INWARD_DETAILS_REQUEST = 'UPDATE_STITCHING_INWARD_DETAILS_REQUEST';
export const UPDATE_STITCHING_INWARD_DETAILS_SUCCESS = 'UPDATE_STITCHING_INWARD_DETAILS_SUCCESS';
export const UPDATE_STITCHING_INWARD_DETAILS_FAILURE = 'UPDATE_STITCHING_INWARD_DETAILS_FAILURE';

// FETCH SINGLE STITCHING_INWARD_DETAILS
export const FETCH_SINGLE_STITCHING_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_STITCHING_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_STITCHING_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_STITCHING_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_STITCHING_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_STITCHING_INWARD_DETAILS_FAILURE';

// DELETE PROPERTIES FOR STITCHING_INWARD DETAILS
export const DELETE_STITCHING_INWARD_DETAILS_REQUEST = 'DELETE_STITCHING_INWARD_DETAILS_REQUEST';
export const DELETE_STITCHING_INWARD_DETAILS_SUCCESS = 'DELETE_STITCHING_INWARD_DETAILS_SUCCESS';
export const DELETE_STITCHING_INWARD_DETAILS_FAILURE = 'DELETE_STITCHING_INWARD_DETAILS_FAILURE';


export const DELETE_STITCHING_INWARD_CUT_PANEL_REQUEST = 'DELETE_STITCHING_INWARD_CUT_PANEL_REQUEST';
export const DELETE_STITCHING_INWARD_CUT_PANEL_SUCCESS = 'DELETE_STITCHING_INWARD_CUT_PANEL_SUCCESS';
export const DELETE_STITCHING_INWARD_CUT_PANEL_FAILURE = 'DELETE_STITCHING_INWARD_CUT_PANEL_FAILURE';

// USERFORM RESET

export const STITCHING_INWARD_DETAILS_USERFORM_RESET = 'STITCHING_INWARD_DETAILS_USERFORM_RESET';

export const STITCHING_INWARD_DETAILS_PO_DETAILS_DISABLED = 'STITCHING_INWARD_DETAILS_PO_DETAILS_DISABLED';
export const RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID = 'RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID';
export const SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID = 'SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID';


export const FETCH_DETAIL_DC_NO_REQUEST = 'FETCH_DETAIL_DC_NO_REQUEST';
export const FETCH_DETAIL_DC_NO_SUCCESS = 'FETCH_DETAIL_DC_NO_SUCCESS';
export const FETCH_DETAIL_DC_NO_FALIURE = 'FETCH_DETAIL_DC_NO_FALIURE';



export const FETCH_CUT_PANEL_GET_REQUEST = 'FETCH_CUT_PANEL_GET_REQUEST';
export const FETCH_CUT_PANEL_GET_SUCCESS = 'FETCH_CUT_PANEL_GET_SUCCESS';
export const FETCH_CUT_PANEL_GET_FALIURE = 'FETCH_CUT_PANEL_GET_FALIURE';


